const homepage = {
  path: 'homepage',
  redirect: to => ({
    path: '/unionLogin',
    query: {
      type: 'zk_stu',
      redirect: to.query.redirect || '/studentResults/query/detail'
    }
  })
}

export default homepage
